export default __webpack_public_path__ + "static/media/s3.50ab3f82.JPG";